var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainBusinessM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1832",
    "data-name": "\\uC0AC\\uAC01\\uD615 1832",
    width: 31.375,
    height: 91.264,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4011",
    "data-name": "\\uADF8\\uB8F9 4011",
    transform: "translate(1400 8483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4007",
    "data-name": "\\uADF8\\uB8F9 4007",
    transform: "translate(-1365.687 -8478.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4007-2",
    "data-name": "\\uADF8\\uB8F9 4007",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_133",
    "data-name": "\\uD328\\uC2A4 133",
    d: "M26.046,43.56c-.27-2-.372-3.964.7-4.765a4.859,4.859,0,0,1,.987-.5,7.432,7.432,0,0,0,1.482-.762c2.659-1.876,2.308-5.483,1.812-8.034-.669-3.44-1.586-8.151-4.88-11.148a11.646,11.646,0,0,0-2.8-1.533,12.705,12.705,0,0,1-2.395-1.252c-.248-.29-.307-.36.339-1.641a11.045,11.045,0,0,0,1.023-2.616,12.8,12.8,0,0,0-.365-6.988A6.3,6.3,0,0,0,16.484.018c-2.643-.2-5.071,1.342-6.516,4.127a10.917,10.917,0,0,0-.681,7.373,11.416,11.416,0,0,0,.909,2.46c.562,1.192.523,1.238.223,1.59a12.652,12.652,0,0,1-2.4,1.255,11.628,11.628,0,0,0-2.8,1.533c-3.295,3-4.21,7.708-4.88,11.148-.5,2.551-.848,6.158,1.812,8.034A7.432,7.432,0,0,0,3.64,38.3a4.874,4.874,0,0,1,.986.5c1.074.8.973,2.765.7,4.766-1.764,13.1,2.3,33.945,7.2,44.938H1.384v2.766H29.99V88.5H18.844c4.906-10.993,8.965-31.841,7.2-44.938M15.579,88.5C10.6,78.275,6.3,57.061,8.07,43.929c.257-1.91.736-5.466-1.791-7.353a7.159,7.159,0,0,0-1.573-.828,5.229,5.229,0,0,1-.954-.47c-1.013-.714-1.238-2.43-.691-5.245.772-3.967,1.606-7.43,4.026-9.631a13.26,13.26,0,0,1,2.07-1.055,9.828,9.828,0,0,0,3.364-1.98c1.5-1.759.735-3.381.176-4.566a8.9,8.9,0,0,1-.711-1.888,8.409,8.409,0,0,1,.437-5.494c.945-1.821,2.307-2.777,3.849-2.643a3.587,3.587,0,0,1,3.061,2.436,9.931,9.931,0,0,1,.286,5.5,8.484,8.484,0,0,1-.793,1.974c-.622,1.234-1.474,2.923.027,4.683a9.812,9.812,0,0,0,3.363,1.98,13.261,13.261,0,0,1,2.07,1.055c2.419,2.2,3.254,5.664,4.026,9.631.548,2.815.322,4.531-.691,5.245a5.24,5.24,0,0,1-.955.47,7.167,7.167,0,0,0-1.573.829c-2.526,1.886-2.047,5.442-1.79,7.352,1.768,13.133-2.53,34.347-7.509,44.569Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1833",
    "data-name": "\\uC0AC\\uAC01\\uD615 1833",
    width: 100,
    height: 100,
    transform: "translate(-1400 -8483)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBusinessM);
export default __webpack_public_path__ + "static/media/main_business_m.97c308c70eb6e8d5ef0ebd4faeaf984c.svg";
export { ForwardRef as ReactComponent };